import { Component, ViewChild } from '@angular/core';
import { Router } from "@angular/router";
import { SalesDashboardComponent } from '../sales-dashboard/sales-dashboard.component';
import { AdminDashboardComponent } from '../admin-dashboard/admin-dashboard.component';




@Component({
  selector: 'app-vestate-leads',
  imports: [
    SalesDashboardComponent,
    AdminDashboardComponent,
  ],
  templateUrl: './vestate-leads.component.html',
  styleUrls: ['../styles/leads.css', './vestate-leads.component.css']
})
export class VestateLeadsComponent {



  constructor() {
  }

  loggedInUser: any;
  userDepartment: any;
  loggedInUserName: any;
  userName: any;
  assistantUser: any;
  ngOnInit() {
    this.userDepartment = localStorage.getItem("department");
    this.loggedInUser = this.userDepartment === "ADMIN" || this.userDepartment === "MARKETING";
    this.assistantUser = this.userDepartment == "ASSISTANT-SALES"
    this.loggedInUserName = localStorage.getItem("username")

  }


  // ngAfterViewInit() {
  //   this.dropListIds = [
  //     "assigned-list",
  //     ...this.emptyColumns.map(col => "drop-list-" + col.index)
  //   ];
  //    const cards = document.querySelectorAll('.animate-card');
  //   cards.forEach((card) => {
  //     card.addEventListener('animationend', () => {
  //       card.classList.remove('animate-card');
  //     });
  //   });
  // }



































}
